import type { FloorSeatPlacement, SeatOccupancyStatus } from "./floorPlan";

/**
 * Seat status colours for the floor drawings. They follow the
 * `<StatusPill>` palette (emerald = available, amber = held, sky = in
 * progress, rose = blocked, violet = permanent) so a seat reads the same
 * on the map as a pill does in a table.
 */
export const SEAT_STATUS_CLASSES: Record<SeatOccupancyStatus, string> = {
  free: "fill-emerald-500/15 stroke-emerald-600 dark:stroke-emerald-400",
  booked: "fill-amber-500/20 stroke-amber-600 dark:stroke-amber-400",
  occupied: "fill-sky-500/25 stroke-sky-600 dark:stroke-sky-400",
  fixed: "fill-violet-500/15 stroke-violet-600 dark:stroke-violet-400",
  blocked: "fill-muted stroke-rose-500/70",
};

export const SEAT_STATUS_SWATCH: Record<SeatOccupancyStatus, string> = {
  free: "bg-emerald-500/20 border-emerald-600",
  booked: "bg-amber-500/25 border-amber-600",
  occupied: "bg-sky-500/30 border-sky-600",
  fixed: "bg-violet-500/20 border-violet-600",
  blocked: "bg-muted border-rose-500/70",
};

export function seatTransform(seat: FloorSeatPlacement): string | undefined {
  if (!seat.rotation) return undefined;
  return `rotate(${seat.rotation} ${seat.x + seat.w / 2} ${seat.y + seat.h / 2})`;
}
